import React from 'react';
import styled from 'styled-components';
import Tag from '../components/tag';

const StyledDiv = styled.div`
  display: grid;
  grid-template-columns: 200px auto;
  grid-template-rows: 1fr;
  grid-gap: 20px;
  max-width:750px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    grid-template-rows: 200px auto;
  }
`;

const ulStyle = {
  display: 'flex',
  alignItems: 'center',
  marginBlockEnd: 0,
  padding: "0 10px",
  flexWrap: 'wrap'
}

const skilsStyle = {
  display: 'flex',
  alignItems: 'center',
  margin: '5px 0'
}
export default function AboutPage() {
  return (
    <section style={{ minHeight: 'calc(100vh - 70px)' }} className="topSection">
      <h1 style={{ textAlign: 'center' }}>About Saveliy Saunin</h1>
      <hr />
      <StyledDiv>
        <img alt="Saveliy Saunin" src="/me.jpg"
          style={{
            width: 200,
            height: 200,
            borderRadius: 20,
            placeSelf: 'center'
          }} />
        <p>
          Since I was a teenager, I have been constantly working on various projects.
          Throughout these years, I have worked on some unique LEGO builds, artwork,
          bike repainting and upgrades, wood crafts, websites, apps, and board games.
          I love to come up with a design and bring it to life
          - it is one of the most exciting experiences for me.
          With every new project, I learn something new and upgrade my skills,
          and I am always excited to learn and create more.
        </p>
      </StyledDiv>
      <div style={{ display: 'grid', placeContent: 'center' }}>
        <h2 style={{ textAlign: 'center' }}>Skill set</h2>
        <hr />
        <div style={skilsStyle}>
          <h3 style={{ fontSize: 18 }}>Skills:</h3>
          <ul style={ulStyle}>
            <Tag tag="prog" />
            <Tag tag="circuit" />
            <Tag tag="d3" />
            <Tag tag="graph" />
          </ul>
        </div>
        <div style={skilsStyle}>
          <h3 style={{ fontSize: 18 }}>Programing Languages:</h3>
          <ul style={ulStyle}>
            <Tag tag="php" />
            <Tag tag="js" />
            <Tag tag="c" />
            <Tag tag="html" />
            <Tag tag="css" />
            <Tag tag="vhdl" />
          </ul>
        </div>
        <div style={skilsStyle}>
          <h3 style={{ fontSize: 18 }}>Web development:</h3>
          <ul style={ulStyle}>
            <Tag tag="react" />
            <Tag tag="rn" />
            <Tag tag="firebase" />
            <Tag tag="stripe" />
          </ul>
        </div>
        <div style={skilsStyle}>
          <h3 style={{ fontSize: 18 }}>Microcontrollers:</h3>
          <ul style={ulStyle}>
            <Tag tag="arduino" />
            <Tag tag="pic" />
          </ul>
        </div>
        <div style={skilsStyle}>
          <h3 style={{ fontSize: 18 }}>Software:</h3>
          <ul style={ulStyle}>
            <Tag tag="ms" />
            <Tag tag="fusion" />
            <Tag tag="eagle" />
            <Tag tag="ltspice" />
          </ul>
        </div>
        <div style={skilsStyle}>
          <h3 style={{ fontSize: 18 }}>Languages:</h3>
          <ul style={ulStyle}>
            <Tag tag="eng" />
            <Tag tag="rus" />
          </ul>
        </div>
        <div style={skilsStyle}>
          <h3 style={{ fontSize: 18 }}>Hobbies:</h3>
          <ul style={ulStyle}>
            <Tag tag="bgames" />
            <Tag tag="biking" />
            <Tag tag="uk" />
          </ul>
        </div>
      </div>
    </section>

  );
}